// extracted by mini-css-extract-plugin
var _1 = "src-components-common-SplitPanel-module__resizer";
var _2 = "src-components-common-SplitPanel-module__sidePanel";
var _3 = "src-components-common-SplitPanel-module__splitPanelRoot";
export { _1 as "resizer", _2 as "sidePanel", _3 as "splitPanelRoot" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"resizer\":\"src-components-common-SplitPanel-module__resizer\",\"sidePanel\":\"src-components-common-SplitPanel-module__sidePanel\",\"splitPanelRoot\":\"src-components-common-SplitPanel-module__splitPanelRoot\"}";
        // 1777708299627
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  